import { lazy } from "react"

const Dashboard = lazy(() => import("../../dashboard"))
const EditTicket = lazy(() => import("../../ticket/edit"))
const ListTicket = lazy(() => import("../../ticket/list"))
const SearchCustomer = lazy(() => import("../../customer"))
const EditCustomer = lazy(() => import("../../customer/edit"))


export default [
  {
    component: Dashboard,
    path: "/",
  },
  {
    component: ListTicket,
    path: "/all-tickets",
  },
  {
    component: EditTicket,
    path: "/ticket/:ticketId"
  },
  {
    component: SearchCustomer,
    path: "/search-customer"
  },
  {
    component: EditCustomer,
    path: "/customer/:fn?/:ln?/:p?/:e?"
  },
  {
    component: EditCustomer,
    path: "/customer-id/:id"
  }
]
